import './input.scss';

import { useState } from 'react';

const LoginInput = ({ name, id, label, type, state, handleChange }) => {

    const [passwordVisibility, SetPasswordVisiblity] = useState(false);

    const ShowPassword = () => {

      SetPasswordVisiblity(!passwordVisibility);

    }

    return (
        <div className="formfield">
          <input type={ type === 'password' ? (passwordVisibility ? 'text' : 'password') : 'text' }
            name={name}
            id={id}
            value={state.input[name]}
            autoComplete="off"
            onChange={handleChange} required />
            <label alt={label} htmlFor={id} placeholder={label}>{label}</label>

            { 
              name === 'password' && 
              <i 
                className={`password-eye-icon fa ${ passwordVisibility ? 'fa-eye' : 'fa-eye-slash'}`} 
                aria-hidden="true"
                onClick={ ShowPassword }
              ></i> 
            }
           
          <span className="validation-errors">{state.validationErrs[name]}</span>
        </div>
    );
  };

export default LoginInput;